export const ENV = {
  FRONTEND_API_URL: import.meta.env?.VITE_FRONTEND_API_URL || '',
  API_URL: import.meta.env?.VITE_API_URL || '',
  VIEW_AS_URL: import.meta.env?.VITE_VIEW_AS_URL || '',
  EPOS_UPLOAD_API_URL: import.meta.env?.VITE_EPOS_UPLOAD_API_URL || '',
  GOOGLE_API_KEY: import.meta.env?.VITE_GOOGLE_API_KEY || '',
} as const;
